// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
// import $http from './http'
import axios from 'axios'


import './reset.css'
import './public.css'

axios.interceptors.response.use(res => {
  if(res.data.code == -1){
      router.app.$router.push('/login')
  }else if(res.data.code == 1){
    store.commit('setUserInfo',res.data.data.user);
  }
  return res;
});

Vue.prototype.baseUrl = '',
Vue.prototype.$http = axios;

Vue.prototype.imgBaseUrl = 'https://daily.t';

Vue.config.productionTip = false

Vue.prototype.updateData = function(time,tips,right,date){
    // let vm = this;
    let data = {SrtTime:time,tips:tips,result:right};
    if(date){
      data.date = date;
    }
    axios.get('/GameDaily/push?rest_key=1',{params:data}).then(res=>{
        console.log(res);
        if(res.data == 'Done'){
          router.app.$router.push('/index');
        }
    })
},

Vue.prototype.randomIndex = function(arr){
  let data = [];
  for(let k=arr.length;k>0;k--){
    let i = parseInt(Math.random()*arr.length);
    data.push(arr.splice(i,1)[0])
  }
  return data;
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js